import { render } from "./TheNavbarSkeleton.vue?vue&type=template&id=63c0eb71&scoped=true&ts=true&lang=pug"
import script from "./TheNavbarSkeleton.vue?vue&type=script&lang=ts&setup=true"
export * from "./TheNavbarSkeleton.vue?vue&type=script&lang=ts&setup=true"

import "./TheNavbarSkeleton.vue?vue&type=style&index=0&id=63c0eb71&lang=scss&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-63c0eb71"]])

export default __exports__